import axios from '../axios/redditlikeApi'

const signUp = form => axios.post('/users', form)

export default {
  signUp
}
